var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { IDL } from "./types/sunrise_stake.js";
import * as anchor from "@coral-xyz/anchor";
import { Program, utils } from "@coral-xyz/anchor";
import { Keypair, PublicKey, SystemProgram, SYSVAR_CLOCK_PUBKEY, Transaction, } from "@solana/web3.js";
import { confirm, findAllTickets, findBSolTokenAccountAuthority, findEpochReportAccount, findGSolMintAuthority, findMSolTokenAccountAuthority, logKeys, marinadeTargetReached, PROGRAM_ID, proportionalBN, setUpAnchor, ZERO, ZERO_BALANCE, toSol, findImpactNFTMintAuthority, getImpactNFT, zip, } from "./util.js";
import { Marinade, MarinadeConfig, } from "@sunrisestake/marinade-ts-sdk";
import { ASSOCIATED_TOKEN_PROGRAM_ID, createAssociatedTokenAccountIdempotentInstruction, TOKEN_PROGRAM_ID, } from "@solana/spl-token";
import { DEFAULT_LP_MIN_PROPORTION, DEFAULT_LP_PROPORTION, EMPTY_EPOCH_REPORT, Environment, MARINADE_TICKET_RENT, NETWORK_FEE, SOLBLAZE_ENABLED, STAKE_POOL_PROGRAM_ID, } from "./constants.js";
import { deposit, depositStakeAccount, liquidUnstake, triggerRebalance, getEpochReportAccount, } from "./marinade.js";
import { blazeDeposit, blazeWithdrawSol, blazeWithdrawStake } from "./blaze.js";
import { getStakePoolAccount } from "./decodeStakePool.js";
import { LockClient } from "./lock.js";
import BN from "bn.js";
// export getStakePoolAccount
export { getStakePoolAccount };
// export all types
export * from "./types/sunrise_stake.js";
export * from "./types/Details.js";
export * from "./types/TicketAccount.js";
export * from "./types/EpochReportAccount.js";
export * from "./types/Solblaze.js";
// export all constants
export * from "./constants.js";
export { toSol, findImpactNFTMintAuthority, ZERO_BALANCE } from "./util.js";
var SunriseStakeClient = /** @class */ (function () {
    function SunriseStakeClient(provider, env, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this.provider = provider;
        this.options = options;
        this.getRegisterStateAccounts = function (treasury, gsolMint, options
        // TODO get these types from the IDL
        ) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var config, marinadeConfig, marinadeState, _a, gsolMintAuthorityBump, _b, msolAuthority, msolAuthorityBump, msolAssociatedTokenAccountAddress, liqPoolAssociatedTokenAccountAddress, _c, bsolAuthority, bsolAuthorityBump, bsolTokenAccountAddress, accounts, parameters;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            config = {
                                gsolMint: gsolMint,
                                programId: this.program.programId,
                                stateAddress: this.env.state,
                                updateAuthority: this.provider.publicKey,
                                treasury: treasury,
                                liqPoolProportion: DEFAULT_LP_PROPORTION,
                                liqPoolMinProportion: DEFAULT_LP_MIN_PROPORTION,
                                impactNFTStateAddress: this.env.impactNFT.state,
                                options: options,
                            };
                            marinadeConfig = new MarinadeConfig({
                                connection: this.provider.connection,
                            });
                            return [4 /*yield*/, new Marinade(marinadeConfig).getMarinadeState()];
                        case 1:
                            marinadeState = _d.sent();
                            _a = findGSolMintAuthority(config), gsolMintAuthorityBump = _a[1];
                            _b = findMSolTokenAccountAuthority(config), msolAuthority = _b[0], msolAuthorityBump = _b[1];
                            return [4 /*yield*/, utils.token.associatedAddress({
                                    mint: marinadeState.mSolMintAddress,
                                    owner: msolAuthority,
                                })];
                        case 2:
                            msolAssociatedTokenAccountAddress = _d.sent();
                            return [4 /*yield*/, utils.token.associatedAddress({
                                    mint: marinadeState.lpMint.address,
                                    owner: msolAuthority,
                                })];
                        case 3:
                            liqPoolAssociatedTokenAccountAddress = _d.sent();
                            _c = findBSolTokenAccountAuthority(config), bsolAuthority = _c[0], bsolAuthorityBump = _c[1];
                            return [4 /*yield*/, utils.token.associatedAddress({
                                    mint: this.env.blaze.bsolMint,
                                    owner: bsolAuthority,
                                })];
                        case 4:
                            bsolTokenAccountAddress = _d.sent();
                            accounts = {
                                state: this.env.state,
                                payer: this.provider.publicKey,
                                mint: gsolMint,
                                msolMint: marinadeState.mSolMintAddress,
                                bsolMint: this.env.blaze.bsolMint,
                                msolTokenAccountAuthority: msolAuthority,
                                msolTokenAccount: msolAssociatedTokenAccountAddress,
                                liqPoolMint: marinadeState.lpMint.address,
                                liqPoolTokenAccount: liqPoolAssociatedTokenAccountAddress,
                                bsolTokenAccountAuthority: bsolAuthority,
                                bsolTokenAccount: bsolTokenAccountAddress,
                                systemProgram: SystemProgram.programId,
                                tokenProgram: TOKEN_PROGRAM_ID,
                                associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
                                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                            };
                            parameters = {
                                marinadeState: marinadeConfig.marinadeStateAddress,
                                blazeState: this.env.blaze.pool,
                                updateAuthority: this.provider.publicKey,
                                treasury: treasury,
                                gsolMintAuthorityBump: gsolMintAuthorityBump,
                                msolAuthorityBump: msolAuthorityBump,
                                bsolAuthorityBump: bsolAuthorityBump,
                                liqPoolProportion: DEFAULT_LP_PROPORTION,
                                liqPoolMinProportion: DEFAULT_LP_MIN_PROPORTION,
                            };
                            return [2 /*return*/, { accounts: accounts, parameters: parameters }];
                    }
                });
            });
        };
        this.program = new Program(IDL, PROGRAM_ID, provider);
        this.staker = this.provider.publicKey;
        this.env = __assign(__assign({}, env), options.environmentOverrides);
    }
    SunriseStakeClient.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Boolean((_a = this.config) === null || _a === void 0 ? void 0 : _a.options.verbose) && console.log.apply(console, args);
    };
    /**
     * Refresh the client's internal state
     */
    SunriseStakeClient.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SunriseStakeClient.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sunriseStakeState, stakePoolInfo, gsolMintAuthority, marinadeConfig, _a, _b, _c, withdrawAuthority, depositAuthority, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.program.account.state.fetch(this.env.state)];
                    case 1:
                        sunriseStakeState = _f.sent();
                        return [4 /*yield*/, getStakePoolAccount(this.provider.connection, this.env.blaze.pool)];
                    case 2:
                        stakePoolInfo = _f.sent();
                        this.config = {
                            gsolMint: sunriseStakeState.gsolMint,
                            treasury: sunriseStakeState.treasury,
                            programId: this.program.programId,
                            stateAddress: this.env.state,
                            updateAuthority: sunriseStakeState.updateAuthority,
                            liqPoolProportion: sunriseStakeState.liqPoolProportion,
                            liqPoolMinProportion: sunriseStakeState.liqPoolMinProportion,
                            impactNFTStateAddress: this.env.impactNFT.state,
                            options: this.options,
                        };
                        this.stakerGSolTokenAccount = PublicKey.findProgramAddressSync([
                            this.staker.toBuffer(),
                            TOKEN_PROGRAM_ID.toBuffer(),
                            sunriseStakeState.gsolMint.toBuffer(),
                        ], ASSOCIATED_TOKEN_PROGRAM_ID)[0];
                        gsolMintAuthority = findGSolMintAuthority(this.config)[0];
                        this.msolTokenAccountAuthority = findMSolTokenAccountAuthority(this.config)[0];
                        this.bsolTokenAccountAuthority = findBSolTokenAccountAuthority(this.config)[0];
                        marinadeConfig = new MarinadeConfig({
                            connection: this.provider.connection,
                            publicKey: this.provider.publicKey,
                            proxyStateAddress: this.env.state,
                            proxySolMintAuthority: gsolMintAuthority,
                            proxySolMintAddress: this.config.gsolMint,
                            msolTokenAccountAuthority: this.msolTokenAccountAuthority,
                            proxyTreasury: this.config.treasury,
                        });
                        this.marinade = new Marinade(marinadeConfig);
                        _a = this;
                        return [4 /*yield*/, this.marinade.getMarinadeState()];
                    case 3:
                        _a.marinadeState = _f.sent();
                        _b = this;
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.marinadeState.mSolMintAddress,
                                owner: this.msolTokenAccountAuthority,
                            })];
                    case 4:
                        _b.msolTokenAccount = _f.sent();
                        _c = this;
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.marinadeState.lpMint.address,
                                owner: this.msolTokenAccountAuthority,
                            })];
                    case 5:
                        _c.liqPoolTokenAccount = _f.sent();
                        withdrawAuthority = PublicKey.findProgramAddressSync([this.env.blaze.pool.toBuffer(), Buffer.from("withdraw")], STAKE_POOL_PROGRAM_ID)[0];
                        depositAuthority = PublicKey.findProgramAddressSync([this.env.blaze.pool.toBuffer(), Buffer.from("deposit")], STAKE_POOL_PROGRAM_ID)[0];
                        this.blazeState = {
                            pool: this.env.blaze.pool,
                            bsolMint: stakePoolInfo.poolMint,
                            validatorList: stakePoolInfo.validatorList,
                            reserveAccount: stakePoolInfo.reserveStake,
                            managerAccount: stakePoolInfo.manager,
                            feesDepot: stakePoolInfo.managerFeeAccount,
                            withdrawAuthority: withdrawAuthority,
                            depositAuthority: depositAuthority,
                        };
                        _d = this;
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: stakePoolInfo.poolMint,
                                owner: this.bsolTokenAccountAuthority,
                            })];
                    case 6:
                        _d.bsolTokenAccount = _f.sent();
                        _e = this;
                        return [4 /*yield*/, LockClient.build(this.config, this.program, this.staker)];
                    case 7:
                        _e.lockClient = _f.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Utility function for sending an transaction and waiting for it to confirm.
     * @param transaction
     * @param signers
     * @param opts
     */
    SunriseStakeClient.prototype.sendAndConfirmTransaction = function (transaction, signers, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.provider
                        .sendAndConfirm(transaction, signers, opts)
                        .catch(function (e) {
                        _this.log(e.logs);
                        throw e;
                    })];
            });
        });
    };
    /**
     * Send and confirm multiple transactions in sequence
     *
     * @param transactions
     * @param signers
     * @param opts
     * @param withRefresh Refresh the client's internal state after sending the transactions (default: false)
     */
    SunriseStakeClient.prototype.sendAndConfirmTransactions = function (transactions, signers, opts, withRefresh) {
        if (signers === void 0) { signers = []; }
        if (withRefresh === void 0) { withRefresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var txesWithSigners, txSigs, _i, txesWithSigners_1, _a, tx, signers_1, txSig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        txesWithSigners = zip(transactions, signers, []);
                        txSigs = [];
                        this.log("Sending transactions: ", transactions.length);
                        _i = 0, txesWithSigners_1 = txesWithSigners;
                        _b.label = 1;
                    case 1:
                        if (!(_i < txesWithSigners_1.length)) return [3 /*break*/, 4];
                        _a = txesWithSigners_1[_i], tx = _a[0], signers_1 = _a[1];
                        return [4 /*yield*/, this.sendAndConfirmTransaction(tx, signers_1, opts)];
                    case 2:
                        txSig = _b.sent();
                        this.log("Transaction sent: ", txSig);
                        txSigs.push(txSig);
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (!withRefresh) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.refresh()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [2 /*return*/, txSigs];
                }
            });
        });
    };
    /**
     * Create a new GSol token account for the staker
     * @param account
     * @param authority
     */
    SunriseStakeClient.prototype.createGSolTokenAccountIx = function (account, authority) {
        if (account === void 0) { account = this.stakerGSolTokenAccount; }
        if (authority === void 0) { authority = this.staker; }
        if (!account || !this.config)
            throw new Error("init not called");
        return createAssociatedTokenAccountIdempotentInstruction(this.provider.publicKey, account, authority, this.config.gsolMint);
    };
    /**
     * Deposit GSol into the staker's GSol token account
     * @param lamports
     * @param recipient The recipient of the gSOL. If not provided, the current staker will be used.
     */
    SunriseStakeClient.prototype.makeBalancedDeposit = function (lamports, recipient) {
        return __awaiter(this, void 0, void 0, function () {
            var details;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.details()];
                    case 1:
                        details = _a.sent();
                        if (marinadeTargetReached(details, this.env.percentageStakeToMarinade) &&
                            SOLBLAZE_ENABLED) {
                            console.log("Routing deposit to Solblaze");
                            return [2 /*return*/, this.depositToBlaze(lamports, recipient)];
                        }
                        console.log("Depositing to marinade");
                        return [2 /*return*/, this.deposit(lamports, recipient)];
                }
            });
        });
    };
    /**
     * Deposit directly to Marinade
     * @deprecated - use makeBalancedDeposit instead
     * @param lamports
     * @param recipient The recipient of the gSOL. If not provided, the current staker will be used.
     */
    SunriseStakeClient.prototype.deposit = function (lamports, recipient) {
        return __awaiter(this, void 0, void 0, function () {
            var recipientAuthority, recipientGsolTokenAccountAddress, _a, gsolTokenAccount, transaction, createUserTokenAccount, depositTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.stakerGSolTokenAccount)
                            throw new Error("init not called");
                        recipientAuthority = recipient !== null && recipient !== void 0 ? recipient : this.staker;
                        if (!recipient) return [3 /*break*/, 2];
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.config.gsolMint,
                                owner: recipientAuthority,
                            })];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = this.stakerGSolTokenAccount;
                        _b.label = 3;
                    case 3:
                        recipientGsolTokenAccountAddress = _a;
                        return [4 /*yield*/, this.provider.connection.getAccountInfo(recipientGsolTokenAccountAddress)];
                    case 4:
                        gsolTokenAccount = _b.sent();
                        transaction = new Transaction();
                        if (!gsolTokenAccount) {
                            createUserTokenAccount = this.createGSolTokenAccountIx(recipientGsolTokenAccountAddress, recipient);
                            transaction.add(createUserTokenAccount);
                        }
                        return [4 /*yield*/, deposit(this.config, this.program, this.marinade, this.marinadeState, this.config.stateAddress, this.provider.publicKey, recipientGsolTokenAccountAddress, lamports)];
                    case 5:
                        depositTx = _b.sent();
                        transaction.add(depositTx);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    /**
     * Deposit directly to Solblaze
     * @deprecated - use makeBalancedDeposit instead
     * @param lamports
     * @param recipient The recipient of the gSOL. If not provided, the current staker will be used.
     */
    SunriseStakeClient.prototype.depositToBlaze = function (lamports, recipient) {
        return __awaiter(this, void 0, void 0, function () {
            var recipientAuthority, recipientGsolTokenAccountAddress, _a, gsolTokenAccount, transaction, createUserTokenAccount, depositTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.config || !this.stakerGSolTokenAccount || !this.blazeState)
                            throw new Error("init not called");
                        recipientAuthority = recipient !== null && recipient !== void 0 ? recipient : this.staker;
                        if (!recipient) return [3 /*break*/, 2];
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.config.gsolMint,
                                owner: recipientAuthority,
                            })];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = this.stakerGSolTokenAccount;
                        _b.label = 3;
                    case 3:
                        recipientGsolTokenAccountAddress = _a;
                        return [4 /*yield*/, this.provider.connection.getAccountInfo(recipientGsolTokenAccountAddress)];
                    case 4:
                        gsolTokenAccount = _b.sent();
                        transaction = new Transaction();
                        if (!gsolTokenAccount) {
                            createUserTokenAccount = this.createGSolTokenAccountIx(recipientGsolTokenAccountAddress, recipient);
                            transaction.add(createUserTokenAccount);
                        }
                        return [4 /*yield*/, blazeDeposit(this.config, this.program, this.blazeState, this.provider.publicKey, recipientGsolTokenAccountAddress, lamports)];
                    case 5:
                        depositTx = _b.sent();
                        transaction.add(depositTx);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    /**
     * Deposit an existing SPL Stake account
     * @param stakeAccountAddress
     */
    SunriseStakeClient.prototype.depositStakeAccount = function (stakeAccountAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, gSolTokenAccount, createUserTokenAccount, depositStakeIx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.stakerGSolTokenAccount)
                            throw new Error("init not called");
                        transaction = new Transaction();
                        return [4 /*yield*/, this.provider.connection.getAccountInfo(this.stakerGSolTokenAccount)];
                    case 1:
                        gSolTokenAccount = _a.sent();
                        if (!gSolTokenAccount) {
                            createUserTokenAccount = this.createGSolTokenAccountIx();
                            transaction.add(createUserTokenAccount);
                        }
                        return [4 /*yield*/, depositStakeAccount(this.config, this.program, this.marinade, this.marinadeState, this.provider.publicKey, stakeAccountAddress, this.stakerGSolTokenAccount)];
                    case 2:
                        depositStakeIx = _a.sent();
                        console.log("Depositing Stake Account...");
                        transaction.add(depositStakeIx);
                        return [2 /*return*/, this.sendAndConfirmTransaction(transaction, [])];
                }
            });
        });
    };
    /**
     * Withdraw GSol from the staker's GSol token account.
     * Note - this currently uses Marinade only.
     * @param lamports
     */
    SunriseStakeClient.prototype.unstake = function (lamports) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var transaction;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.stakerGSolTokenAccount ||
                            !this.blazeState)
                            throw new Error("init not called");
                        return [4 /*yield*/, liquidUnstake(this.config, this.blazeState, this.marinade, this.marinadeState, this.program, this.env.state, this.staker, this.stakerGSolTokenAccount, lamports)];
                    case 1:
                        transaction = _b.sent();
                        Boolean((_a = this.config) === null || _a === void 0 ? void 0 : _a.options.verbose) && logKeys(transaction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    /**
     * Permissionless admin function.
     *
     * Recover delayed unstake tickets from rebalances in the previous epoch, if necessary
     * Note, even if there are no tickets to recover, if the epoch report references the previous epoch
     * we call this instruction anyway as part of triggerRebalance, to update the epoch.
     */
    SunriseStakeClient.prototype.recoverTickets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var marinadeProgram, _a, epochReportAccountAddress, epochReport, currentEpoch, previousEpochTickets, previousEpochTicketAccountMetas, accounts;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.bsolTokenAccount ||
                            !this.stakerGSolTokenAccount ||
                            !this.blazeState)
                            throw new Error("init not called");
                        marinadeProgram = this.marinade.marinadeFinanceProgram.programAddress;
                        return [4 /*yield*/, getEpochReportAccount(this.config, this.program)];
                    case 1:
                        _a = _c.sent(), epochReportAccountAddress = _a.address, epochReport = _a.account;
                        return [4 /*yield*/, this.program.provider.connection.getEpochInfo()];
                    case 2:
                        currentEpoch = _c.sent();
                        if (!epochReport) {
                            // no epoch report account found at all - something went wrong
                            throw new Error("No epoch report account found during recoverTickets");
                        }
                        this.log("Current epoch: ".concat(currentEpoch.epoch, ", epoch report epoch: ").concat(epochReport.epoch.toNumber()));
                        if (currentEpoch.epoch === epochReport.epoch.toNumber()) {
                            // nothing to do here - the report account is for the current epoch, so we cannot recover any tickets yet
                            this.log("Skipping recoverTickets, epoch report is for current epoch");
                            return [2 /*return*/, null];
                        }
                        else {
                            this.log("Updating epoch report account and recovering tickets from previous epoch");
                        }
                        return [4 /*yield*/, findAllTickets(this.program.provider.connection, this.config, 
                            // change BigInt(1) to 1n when we target ES2020 in tsconfig.json
                            BigInt(epochReport.epoch.toString()), epochReport.tickets.toNumber())];
                    case 3:
                        previousEpochTickets = _c.sent();
                        previousEpochTicketAccountMetas = previousEpochTickets.map(function (ticket) { return ({
                            pubkey: ticket,
                            isSigner: false,
                            isWritable: true,
                        }); });
                        _b = {
                            state: this.config.stateAddress,
                            payer: this.staker,
                            marinadeState: this.marinadeState.marinadeStateAddress,
                            blazeState: this.blazeState.pool,
                            gsolMint: this.config.gsolMint,
                            msolMint: this.marinadeState.mSolMint.address,
                            bsolMint: this.blazeState.bsolMint,
                            liqPoolMint: this.marinadeState.lpMint.address
                        };
                        return [4 /*yield*/, this.marinadeState.lpMintAuthority()];
                    case 4:
                        _b.liqPoolMintAuthority = _c.sent();
                        return [4 /*yield*/, this.marinadeState.solLeg()];
                    case 5:
                        _b.liqPoolSolLegPda = _c.sent(),
                            _b.liqPoolMsolLeg = this.marinadeState.mSolLeg;
                        return [4 /*yield*/, this.marinadeState.mSolLegAuthority()];
                    case 6:
                        _b.liqPoolMsolLegAuthority = _c.sent(),
                            _b.liqPoolTokenAccount = this.liqPoolTokenAccount;
                        return [4 /*yield*/, this.marinadeState.reserveAddress()];
                    case 7:
                        accounts = (_b.reservePda = _c.sent(),
                            _b.treasuryMsolAccount = this.marinadeState.treasuryMsolAccount,
                            _b.getMsolFrom = this.msolTokenAccount,
                            _b.getMsolFromAuthority = this.msolTokenAccountAuthority,
                            _b.getBsolFrom = this.bsolTokenAccount,
                            _b.getBsolFromAuthority = this.bsolTokenAccountAuthority,
                            _b.epochReportAccount = epochReportAccountAddress,
                            _b.systemProgram = SystemProgram.programId,
                            _b.tokenProgram = TOKEN_PROGRAM_ID,
                            _b.clock = SYSVAR_CLOCK_PUBKEY,
                            _b.marinadeProgram = marinadeProgram,
                            _b);
                        return [2 /*return*/, this.program.methods
                                .recoverTickets()
                                .accounts(accounts)
                                .remainingAccounts(previousEpochTicketAccountMetas)
                                .instruction()];
                }
            });
        });
    };
    /**
     * Permissionless admin function.
     *
     * Update the epoch report account to the current epoch.
     * The epoch report account is used to track the total yield earned by the protocol
     * as well as the amount of in-flight delayed unstake tickets created through pool rebalancing.
     */
    SunriseStakeClient.prototype.updateEpochReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var marinadeProgram, _a, epochReportAccountAddress, epochReport, accounts;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.bsolTokenAccount ||
                            !this.stakerGSolTokenAccount ||
                            !this.blazeState)
                            throw new Error("init not called");
                        marinadeProgram = this.marinade.marinadeFinanceProgram.programAddress;
                        return [4 /*yield*/, getEpochReportAccount(this.config, this.program)];
                    case 1:
                        _a = _c.sent(), epochReportAccountAddress = _a.address, epochReport = _a.account;
                        if (!epochReport) {
                            // no epoch report account found at all - something went wrong
                            throw new Error("No epoch report account found during recoverTickets");
                        }
                        _b = {
                            state: this.config.stateAddress,
                            payer: this.staker,
                            marinadeState: this.marinadeState.marinadeStateAddress,
                            blazeState: this.blazeState.pool,
                            gsolMint: this.config.gsolMint,
                            msolMint: this.marinadeState.mSolMint.address,
                            bsolMint: this.blazeState.bsolMint,
                            liqPoolMint: this.marinadeState.lpMint.address
                        };
                        return [4 /*yield*/, this.marinadeState.lpMintAuthority()];
                    case 2:
                        _b.liqPoolMintAuthority = _c.sent();
                        return [4 /*yield*/, this.marinadeState.solLeg()];
                    case 3:
                        _b.liqPoolSolLegPda = _c.sent(),
                            _b.liqPoolMsolLeg = this.marinadeState.mSolLeg;
                        return [4 /*yield*/, this.marinadeState.mSolLegAuthority()];
                    case 4:
                        accounts = (_b.liqPoolMsolLegAuthority = _c.sent(),
                            _b.liqPoolTokenAccount = this.liqPoolTokenAccount,
                            _b.treasuryMsolAccount = this.marinadeState.treasuryMsolAccount,
                            _b.getMsolFrom = this.msolTokenAccount,
                            _b.getMsolFromAuthority = this.msolTokenAccountAuthority,
                            _b.getBsolFrom = this.bsolTokenAccount,
                            _b.getBsolFromAuthority = this.bsolTokenAccountAuthority,
                            _b.epochReportAccount = epochReportAccountAddress,
                            _b.systemProgram = SystemProgram.programId,
                            _b.tokenProgram = TOKEN_PROGRAM_ID,
                            _b.clock = SYSVAR_CLOCK_PUBKEY,
                            _b.marinadeProgram = marinadeProgram,
                            _b);
                        return [4 /*yield*/, this.program.methods
                                .updateEpochReport()
                                .accounts(accounts)
                                .rpc()
                                .then(confirm(this.provider.connection))];
                    case 5:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Permissionless admin function.
     *
     * Trigger a rebalance without doing anything else.
     *
     * A rebalance is necessary when the amount of funds in one of the pools is too low.
     * This happens when too many people withdraw from the liquidity pool at once.
     * Rebalancing moves a proportion of the stake pool into the liquidity pool, using a delayed unstake.
     * This must then be redeemed in the next epoch by making a recover-tickets call.
     */
    SunriseStakeClient.prototype.triggerRebalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var recoverInstruction, rebalanceInstruction, instructions, transaction;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.stakerGSolTokenAccount)
                            throw new Error("init not called");
                        return [4 /*yield*/, this.recoverTickets()];
                    case 1:
                        recoverInstruction = _b.sent();
                        return [4 /*yield*/, triggerRebalance(this.config, this.marinade, this.marinadeState, this.program, this.env.state, this.provider.publicKey)];
                    case 2:
                        rebalanceInstruction = (_b.sent()).instruction;
                        instructions = [recoverInstruction, rebalanceInstruction].filter(Boolean);
                        transaction = (_a = new Transaction()).add.apply(_a, instructions);
                        return [2 /*return*/, this.sendAndConfirmTransaction(transaction, [])];
                }
            });
        });
    };
    /**
     * Print a detailed report of the current state of the protocol.
     */
    SunriseStakeClient.prototype.report = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var details, inflightTotal, totalValue, mpShare, bpShare, lpShare, inflightShare, missingValue, missingValueShare, report;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.details()];
                    case 1:
                        details = _b.sent();
                        inflightTotal = details.epochReport.totalOrderedLamports;
                        totalValue = details.mpDetails.msolValue
                            .add(details.bpDetails.bsolValue)
                            .add(details.lpDetails.lpSolValue)
                            .add(inflightTotal);
                        mpShare = details.mpDetails.msolValue.muln(10000).div(totalValue).toNumber() / 100;
                        bpShare = details.bpDetails.bsolValue.muln(10000).div(totalValue).toNumber() / 100;
                        lpShare = details.lpDetails.lpSolValue.muln(10000).div(totalValue).toNumber() /
                            100;
                        inflightShare = inflightTotal.muln(10000).div(totalValue).toNumber() / 100;
                        missingValue = totalValue.sub(new BN(details.balances.gsolSupply.amount));
                        missingValueShare = missingValue.muln(10000).div(totalValue).toNumber() / 100;
                        report = {
                            "gSOL Supply": (_a = details.balances.gsolSupply.uiAmountString) !== null && _a !== void 0 ? _a : "-",
                            "Marinade Stake Pool Value": "".concat(toSol(details.mpDetails.msolValue), " (").concat(mpShare.toString(), "%)"),
                            "SolBlaze Stake Pool Value": "".concat(toSol(details.bpDetails.bsolValue), " (").concat(bpShare.toString(), "%)"),
                            "Liquidity Pool Value": "".concat(toSol(details.lpDetails.lpSolValue), " (").concat(lpShare.toString(), "%)"),
                            "Total Value": "".concat(toSol(totalValue)),
                            "Open Orders": "".concat(details.epochReport.tickets.toNumber()),
                            "Open Order value": "".concat(toSol(inflightTotal), " (").concat(inflightShare.toString(), "%)"),
                            "Extractable Yield (calculated)": "".concat(toSol(missingValue), " (").concat(missingValueShare.toString(), "%)"),
                            "Extractable Yield": "".concat(toSol(details.extractableYield)),
                            "Epoch Report Epoch": "".concat(details.epochReport.epoch.toNumber()),
                            "Current Epoch": "".concat(details.currentEpoch.epoch),
                            "Epoch Report Tickets": "".concat(details.epochReport.tickets.toNumber()),
                        };
                        Object.keys(report).forEach(function (key) {
                            _this.log(key, ":", report[key]);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Trigger a delayed unstake of the given amount of SOL.
     * This creates a ticket, which can be redeemed for SOL in the next epoch.
     * Note - it currently works only with marinade.
     * @param lamports
     */
    SunriseStakeClient.prototype.orderUnstake = function (lamports) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, transaction, newTicketAccount, proxyTicketAccount;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount)
                            throw new Error("init not called");
                        return [4 /*yield*/, this.marinade.orderUnstake(lamports, this.msolTokenAccount)];
                    case 1:
                        _b = _c.sent(), transaction = _b.transaction, newTicketAccount = _b.newTicketAccount, proxyTicketAccount = _b.proxyTicketAccount;
                        Boolean((_a = this.config) === null || _a === void 0 ? void 0 : _a.options.verbose) && logKeys(transaction);
                        return [2 /*return*/, [transaction, [newTicketAccount, proxyTicketAccount]]];
                }
            });
        });
    };
    SunriseStakeClient.prototype.toTicketAccount = function (sunriseTicketAccount, address) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var marinadeTicketAccount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.marinade) === null || _a === void 0 ? void 0 : _a.getDelayedUnstakeTicket(sunriseTicketAccount.marinadeTicketAccount))];
                    case 1:
                        marinadeTicketAccount = _b.sent();
                        if (!marinadeTicketAccount)
                            throw new Error("Marinade ticket with address ".concat(sunriseTicketAccount.marinadeTicketAccount.toString(), " not found"));
                        return [2 /*return*/, __assign(__assign({ address: address }, sunriseTicketAccount), marinadeTicketAccount)];
                }
            });
        });
    };
    /**
     * Find all delayed-unstake tickets for the current user
     */
    SunriseStakeClient.prototype.getDelayedUnstakeTickets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var beneficiary, ticketAccounts, resolvedTicketAccountPromises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.marinade)
                            throw new Error("init not called");
                        beneficiary = this.provider.publicKey;
                        return [4 /*yield*/, this.program.account.sunriseTicketAccount.all([
                                {
                                    memcmp: {
                                        offset: 8 + 32 + 32,
                                        bytes: beneficiary.toBase58(),
                                    },
                                },
                            ])];
                    case 1:
                        ticketAccounts = _a.sent();
                        resolvedTicketAccountPromises = ticketAccounts.map(function (_a) {
                            var account = _a.account, publicKey = _a.publicKey;
                            return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                                return [2 /*return*/, this.toTicketAccount(account, publicKey)];
                            }); });
                        });
                        return [2 /*return*/, Promise.all(resolvedTicketAccountPromises)];
                }
            });
        });
    };
    /**
     * Redeem a delayed-unstake ticket and send the SOL to the given address.
     * @param ticketAccount
     */
    SunriseStakeClient.prototype.claimUnstakeTicket = function (ticketAccount) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var reservePda, marinadeProgram, accounts, transaction;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.marinade || !this.marinadeState)
                            throw new Error("init not called");
                        return [4 /*yield*/, this.marinadeState.reserveAddress()];
                    case 1:
                        reservePda = _b.sent();
                        marinadeProgram = this.marinade.marinadeFinanceProgram.programAddress;
                        accounts = {
                            state: this.env.state,
                            marinadeState: this.marinadeState.marinadeStateAddress,
                            reservePda: reservePda,
                            marinadeTicketAccount: ticketAccount.marinadeTicketAccount,
                            sunriseTicketAccount: ticketAccount.address,
                            msolAuthority: this.msolTokenAccountAuthority,
                            transferSolTo: this.staker,
                            systemProgram: SystemProgram.programId,
                            clock: SYSVAR_CLOCK_PUBKEY,
                            marinadeProgram: marinadeProgram,
                        };
                        return [4 /*yield*/, this.program.methods
                                .claimUnstakeTicket()
                                .accounts(accounts)
                                .transaction()];
                    case 2:
                        transaction = _b.sent();
                        Boolean((_a = this.config) === null || _a === void 0 ? void 0 : _a.options.verbose) && logKeys(transaction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    /**
     * Immediately withdraw the given amount of SOL from the Solblaze stake pool.
     * @param amount
     */
    SunriseStakeClient.prototype.withdrawFromBlaze = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var withdrawIx, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.blazeState ||
                            !this.config ||
                            !this.stakerGSolTokenAccount ||
                            !this.bsolTokenAccount)
                            throw new Error("init not called");
                        return [4 /*yield*/, blazeWithdrawSol(this.config, this.program, this.blazeState, this.provider.publicKey, this.stakerGSolTokenAccount, amount)];
                    case 1:
                        withdrawIx = _a.sent();
                        transaction = new Transaction().add(withdrawIx);
                        return [2 /*return*/, this.sendAndConfirmTransaction(transaction, [])];
                }
            });
        });
    };
    /**
     * Withdraw the given amount of SOL from the Solblaze stake pool into a stake account
     * @param newStakeAccount
     * @param amount
     */
    SunriseStakeClient.prototype.withdrawStakeFromBlaze = function (newStakeAccount, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var withdrawStakeIx, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.blazeState ||
                            !this.config ||
                            !this.stakerGSolTokenAccount ||
                            !this.bsolTokenAccount)
                            throw new Error("init not called");
                        return [4 /*yield*/, blazeWithdrawStake(this.config, this.program, this.blazeState, newStakeAccount, this.provider.publicKey, this.stakerGSolTokenAccount, amount)];
                    case 1:
                        withdrawStakeIx = _a.sent();
                        transaction = new Transaction().add(withdrawStakeIx);
                        return [2 /*return*/, this.sendAndConfirmTransaction(transaction, [])];
                }
            });
        });
    };
    /**
     * Create a new EpochReport account for a sunrise state instance.
     * This should be done only once per state, and must be signed by the update authority
     */
    SunriseStakeClient.prototype.initEpochReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var liqPoolSolLegPda, epochReportAccountAddress, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.blazeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.msolTokenAccountAuthority ||
                            !this.liqPoolTokenAccount) {
                            throw new Error("init not called");
                        }
                        return [4 /*yield*/, this.marinadeState.solLeg()];
                    case 1:
                        liqPoolSolLegPda = _a.sent();
                        epochReportAccountAddress = findEpochReportAccount(this.config)[0];
                        accounts = {
                            state: this.env.state,
                            marinadeState: this.marinadeState.marinadeStateAddress,
                            blazeState: this.blazeState.pool,
                            msolMint: this.marinadeState.mSolMintAddress,
                            gsolMint: this.config.gsolMint,
                            bsolMint: this.blazeState.bsolMint,
                            liqPoolMint: this.marinadeState.lpMint.address,
                            liqPoolSolLegPda: liqPoolSolLegPda,
                            liqPoolMsolLeg: this.marinadeState.mSolLeg,
                            liqPoolTokenAccount: this.liqPoolTokenAccount,
                            treasuryMsolAccount: this.marinadeState.treasuryMsolAccount,
                            getMsolFrom: this.msolTokenAccount,
                            getMsolFromAuthority: this.msolTokenAccountAuthority,
                            getBsolFrom: this.bsolTokenAccount,
                            getBsolFromAuthority: this.bsolTokenAccountAuthority,
                            epochReportAccount: epochReportAccountAddress,
                            treasury: this.config.treasury,
                            systemProgram: SystemProgram.programId,
                        };
                        return [2 /*return*/, this.program.methods
                                .initEpochReport(new BN(0))
                                .accounts(accounts)
                                .rpc()];
                }
            });
        });
    };
    /**
     * Get the EpochReport account for this sunrise state instance
     * The EpochReport account contains running totals of the state's accrued yield,
     * and is updated regularly
     */
    SunriseStakeClient.prototype.getEpochReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config) {
                            throw new Error("init not called");
                        }
                        return [4 /*yield*/, getEpochReportAccount(this.config, this.program)];
                    case 1:
                        account = (_a.sent()).account;
                        // The update authority must create the epoch report account for this sunrise state instance
                        if (!account)
                            throw new Error("Epoch report account not found");
                        return [2 /*return*/, account];
                }
            });
        });
    };
    /**
     * Create an instruction that extracts yield from the sunrise protocol and sends it to the designated
     * yield account.
     *
     * This is a permissionless crank operation that can be called by anyone.
     */
    SunriseStakeClient.prototype.extractYieldIx = function () {
        return __awaiter(this, void 0, void 0, function () {
            var marinadeProgram, liqPoolSolLegPda, epochReportAccount, accounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.blazeState ||
                            !this.marinade ||
                            !this.config ||
                            !this.msolTokenAccount ||
                            !this.msolTokenAccountAuthority ||
                            !this.liqPoolTokenAccount) {
                            throw new Error("init not called");
                        }
                        marinadeProgram = this.marinade.marinadeFinanceProgram.programAddress;
                        return [4 /*yield*/, this.marinadeState.solLeg()];
                    case 1:
                        liqPoolSolLegPda = _a.sent();
                        epochReportAccount = findEpochReportAccount(this.config)[0];
                        accounts = {
                            state: this.env.state,
                            marinadeState: this.marinadeState.marinadeStateAddress,
                            blazeState: this.blazeState.pool,
                            msolMint: this.marinadeState.mSolMintAddress,
                            gsolMint: this.config.gsolMint,
                            bsolMint: this.blazeState.bsolMint,
                            liqPoolMint: this.marinadeState.lpMint.address,
                            liqPoolSolLegPda: liqPoolSolLegPda,
                            liqPoolMsolLeg: this.marinadeState.mSolLeg,
                            liqPoolTokenAccount: this.liqPoolTokenAccount,
                            treasuryMsolAccount: this.marinadeState.treasuryMsolAccount,
                            getMsolFrom: this.msolTokenAccount,
                            getMsolFromAuthority: this.msolTokenAccountAuthority,
                            getBsolFrom: this.bsolTokenAccount,
                            getBsolFromAuthority: this.bsolTokenAccountAuthority,
                            epochReportAccount: epochReportAccount,
                            treasury: this.config.treasury,
                            systemProgram: SystemProgram.programId,
                            tokenProgram: TOKEN_PROGRAM_ID,
                            marinadeProgram: marinadeProgram,
                        };
                        return [2 /*return*/, this.program.methods
                                .extractToTreasury()
                                .accounts(accounts)
                                .instruction()];
                }
            });
        });
    };
    /**
     * Creates and submits an extractYield transaction that extracts yield from the sunrise protocol and sends it to the designated
     * yield account.
     *
     * This is a permissionless crank operation that can be called by anyone.
     */
    SunriseStakeClient.prototype.extractYield = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instruction, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.extractYieldIx()];
                    case 1:
                        instruction = _a.sent();
                        transaction = new Transaction().add(instruction);
                        transaction.feePayer = this.staker;
                        return [2 /*return*/, this.sendAndConfirmTransaction(transaction)];
                }
            });
        });
    };
    /**
     * Calculates the cost of withdrawing a given amount of lamports, given the current state of the pools
     * @param withdrawalLamports
     * @param details
     */
    SunriseStakeClient.prototype.calculateWithdrawalFee = function (withdrawalLamports, details) {
        // Calculate how much can be withdrawn from the lp (without fee)
        var lpSolShare = details.lpDetails.lpSolShare;
        var preferredMinLiqPoolValue = new BN(details.balances.gsolSupply.amount)
            .muln(DEFAULT_LP_MIN_PROPORTION)
            .divn(100);
        var postUnstakeLpSolValue = new BN(lpSolShare).sub(withdrawalLamports);
        // Calculate how much will be withdrawn through liquid unstaking (with fee)
        var amountBeingLiquidUnstaked = withdrawalLamports.sub(lpSolShare);
        // Determine if a rebalance will occur (if the lp value is too low)
        // This will incur a cost due to the unstake ticket rent
        var amountToOrderUnstake = new BN(preferredMinLiqPoolValue).sub(postUnstakeLpSolValue);
        var rentForOrderUnstakeTicket = amountToOrderUnstake.gt(ZERO)
            ? MARINADE_TICKET_RENT
            : 0;
        this.log("withdrawal lamports: ", withdrawalLamports.toString());
        this.log("lp sol share: ", lpSolShare.toString());
        this.log("preferred min lp value: ", preferredMinLiqPoolValue.toString());
        this.log("post unstake lp sol value: ", postUnstakeLpSolValue.toString());
        this.log("amount being liquid unstaked: ", amountBeingLiquidUnstaked.toString());
        this.log("amount to order unstake: ", amountToOrderUnstake.toString());
        this.log("rent for order unstake: ", rentForOrderUnstakeTicket.toString());
        var ticketFee = rentForOrderUnstakeTicket;
        var totalFee = rentForOrderUnstakeTicket > 0
            ? new BN(rentForOrderUnstakeTicket + 2 * NETWORK_FEE)
            : ZERO;
        this.log("base fee for order unstake: ", totalFee.toString());
        if (amountBeingLiquidUnstaked.lte(ZERO)) {
            return {
                liquidUnstakeFee: ZERO,
                ticketFee: ticketFee,
                totalFee: totalFee,
            };
        }
        var marinadeUnstake;
        var msolValue = details.mpDetails.msolValue;
        var bsolValue = details.bpDetails.bsolValue;
        if (msolValue >= bsolValue) {
            marinadeUnstake =
                msolValue > amountBeingLiquidUnstaked
                    ? amountBeingLiquidUnstaked
                    : msolValue;
        }
        else {
            marinadeUnstake =
                bsolValue > amountBeingLiquidUnstaked
                    ? new BN(0)
                    : amountBeingLiquidUnstaked.sub(bsolValue);
        }
        var blazeUnstake = amountBeingLiquidUnstaked.sub(marinadeUnstake);
        var blazeUnstakeFee = blazeUnstake
            .mul(details.bpDetails.solWithdrawalFee.numerator)
            .div(details.bpDetails.solWithdrawalFee.denominator);
        var marinadeUnstakeFee = marinadeUnstake.muln(3).divn(1000);
        var liquidUnstakeFee = blazeUnstakeFee.add(marinadeUnstakeFee);
        totalFee = totalFee.add(liquidUnstakeFee);
        this.log({
            withdrawalLamports: withdrawalLamports.toString(),
            lpSolShare: lpSolShare.toString(),
            amountBeingLiquidUnstaked: amountBeingLiquidUnstaked.toString(),
            marinadeUnstake: marinadeUnstake.toString(),
            blazeUnstake: blazeUnstake.toString(),
            marinadeUnstakeFee: marinadeUnstakeFee.toString(),
            blazeUnstakeFee: blazeUnstakeFee.toString(),
            liquidUnstakeFee: liquidUnstakeFee.toString(),
            msolValue: msolValue.toString(),
            bsolValue: bsolValue.toString(),
            totalFee: totalFee.toString(),
        });
        return {
            liquidUnstakeFee: liquidUnstakeFee,
            ticketFee: ticketFee,
            totalFee: totalFee,
        };
    };
    /**
     * Returns an object containing the current state of the Sunrise protocol,
     * as well as balances and impact nft status for the user
     */
    SunriseStakeClient.prototype.details = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var currentEpochPromise, lpMintInfoPromise, lpMsolBalancePromise, solLeg, solLegBalancePromise, balancesPromise, lockAccountPromise, impactNFTPromise, _c, currentEpoch, lpMintInfo, lpSolLegBalance, lpMsolBalance, balances, lockAccountDetails, impactNFT, availableLiqPoolSolLegBalance, lpMsolShare, lpSolShare, solValueOlpMSolShare, lpSolValue, solValueOfMSol, mpDetails, lpDetails, epochReport, stakePoolInfo, _d, bsolPrice, bsolValue, bpDetails, lockDetails, nftSummary, impactNFTDetails, detailsWithoutYield, extractableYield;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.marinadeState ||
                            !this.stakerGSolTokenAccount ||
                            !this.msolTokenAccount ||
                            !this.config)
                            throw new Error("init not called");
                        currentEpochPromise = this.provider.connection.getEpochInfo();
                        lpMintInfoPromise = this.marinadeState.lpMint.mintInfo();
                        lpMsolBalancePromise = this.provider.connection.getTokenAccountBalance(this.marinadeState.mSolLeg);
                        return [4 /*yield*/, this.marinadeState.solLeg()];
                    case 1:
                        solLeg = _e.sent();
                        solLegBalancePromise = this.provider.connection.getBalance(solLeg);
                        balancesPromise = this.balance();
                        return [4 /*yield*/, this.getLockAccount(true)];
                    case 2:
                        lockAccountPromise = _e.sent();
                        return [4 /*yield*/, getImpactNFT(this.config, this.staker, this.provider)];
                    case 3:
                        impactNFTPromise = _e.sent();
                        return [4 /*yield*/, Promise.all([
                                currentEpochPromise,
                                lpMintInfoPromise,
                                solLegBalancePromise,
                                lpMsolBalancePromise,
                                balancesPromise,
                                lockAccountPromise,
                                impactNFTPromise,
                            ])];
                    case 4:
                        _c = _e.sent(), currentEpoch = _c[0], lpMintInfo = _c[1], lpSolLegBalance = _c[2], lpMsolBalance = _c[3], balances = _c[4], lockAccountDetails = _c[5], impactNFT = _c[6];
                        availableLiqPoolSolLegBalance = new BN(lpSolLegBalance).sub(this.marinadeState.state.rentExemptForTokenAcc);
                        lpMsolShare = proportionalBN(new BN(balances.liqPoolBalance.amount), new BN(lpMsolBalance.value.amount), new BN(lpMintInfo.supply.toString()));
                        lpSolShare = proportionalBN(new BN(balances.liqPoolBalance.amount), availableLiqPoolSolLegBalance, new BN(lpMintInfo.supply.toString()));
                        solValueOlpMSolShare = this.computeLamportsFromMSol(lpMsolShare, this.marinadeState);
                        lpSolValue = lpSolShare.add(solValueOlpMSolShare);
                        solValueOfMSol = this.computeLamportsFromMSol(new BN(balances.msolBalance.amount), this.marinadeState);
                        mpDetails = {
                            msolPrice: this.marinadeState.mSolPrice,
                            msolValue: solValueOfMSol,
                            stakeDelta: this.marinadeState.stakeDelta().toNumber(),
                        };
                        lpDetails = {
                            mintAddress: this.marinadeState.lpMint.address.toBase58(),
                            supply: lpMintInfo.supply,
                            mintAuthority: (_a = lpMintInfo.mintAuthority) === null || _a === void 0 ? void 0 : _a.toBase58(),
                            decimals: lpMintInfo.decimals,
                            lpSolShare: lpSolShare,
                            lpMsolShare: lpMsolShare,
                            lpSolValue: lpSolValue,
                            msolLeg: this.marinadeState.mSolLeg.toBase58(),
                        };
                        return [4 /*yield*/, getEpochReportAccount(this.config, this.program)];
                    case 5:
                        epochReport = (_e.sent()).account;
                        return [4 /*yield*/, getStakePoolAccount(this.provider.connection, this.env.blaze.pool)];
                    case 6:
                        stakePoolInfo = _e.sent();
                        _d = this.computeLamportsFromBSol(new BN(balances.bsolBalance.amount), stakePoolInfo), bsolPrice = _d[0], bsolValue = _d[1];
                        bpDetails = {
                            pool: this.env.blaze.pool.toString(),
                            bsolPrice: bsolPrice,
                            bsolValue: bsolValue,
                            solWithdrawalFee: {
                                numerator: stakePoolInfo.solWithdrawalFee.numerator,
                                denominator: stakePoolInfo.solWithdrawalFee.denominator,
                            },
                        };
                        lockDetails = lockAccountDetails.lockAccount &&
                            lockAccountDetails.tokenAccount &&
                            lockAccountDetails.lockAccount.startEpoch &&
                            lockAccountDetails.lockAccount.updatedToEpoch
                            ? {
                                lockAccount: lockAccountDetails.lockAccountAddress,
                                lockTokenAccount: lockAccountDetails.tokenAccountAddress,
                                startEpoch: lockAccountDetails.lockAccount.startEpoch,
                                updatedToEpoch: lockAccountDetails.lockAccount.updatedToEpoch,
                                amountLocked: new BN("".concat(lockAccountDetails.tokenAccount.amount)),
                                yield: lockAccountDetails.lockAccount.yieldAccruedByOwner,
                                currentLevel: lockAccountDetails.currentLevel,
                                yieldToNextLevel: lockAccountDetails.yieldToNextLevel,
                                unrealizedYield: lockAccountDetails.unrealizedYield,
                            }
                            : undefined;
                        nftSummary = this.config.impactNFTStateAddress
                            ? {
                                stateAddress: this.config.impactNFTStateAddress,
                                mintAuthority: findImpactNFTMintAuthority(this.config)[0],
                                mint: impactNFT.mint,
                                tokenAccount: impactNFT.tokenAccount,
                            }
                            : undefined;
                        impactNFTDetails = (impactNFT === null || impactNFT === void 0 ? void 0 : impactNFT.exists)
                            ? nftSummary
                            : undefined;
                        detailsWithoutYield = {
                            staker: this.staker.toBase58(),
                            balances: balances,
                            currentEpoch: currentEpoch,
                            epochReport: epochReport !== null && epochReport !== void 0 ? epochReport : EMPTY_EPOCH_REPORT,
                            stakerGSolTokenAccount: this.stakerGSolTokenAccount.toBase58(),
                            sunriseStakeConfig: {
                                gsolMint: this.config.gsolMint.toBase58(),
                                programId: this.config.programId.toBase58(),
                                stateAddress: this.config.stateAddress.toBase58(),
                                treasury: this.config.treasury.toBase58(),
                                msolTokenAccount: this.msolTokenAccount.toBase58(),
                                msolTokenAccountAuthority: (_b = this.msolTokenAccountAuthority) === null || _b === void 0 ? void 0 : _b.toBase58(),
                            },
                            marinadeFinanceProgramId: this.marinadeState.marinadeFinanceProgramId.toBase58(),
                            marinadeStateAddress: this.marinadeState.marinadeStateAddress.toBase58(),
                            mpDetails: mpDetails,
                            lpDetails: lpDetails,
                            bpDetails: bpDetails,
                            lockDetails: lockDetails,
                            impactNFTDetails: impactNFTDetails,
                        };
                        extractableYield = this.calculateExtractableYield(detailsWithoutYield);
                        return [2 /*return*/, __assign(__assign({}, detailsWithoutYield), { extractableYield: extractableYield })];
                }
            });
        });
    };
    SunriseStakeClient.prototype.computeLamportsFromMSol = function (msolAmount, marinadeState) {
        var totalCoolingDown = marinadeState.state.stakeSystem.delayedUnstakeCoolingDown.add(marinadeState.state.emergencyCoolingDown);
        var totalLamportsUnderControl = marinadeState.state.validatorSystem.totalActiveBalance
            .add(totalCoolingDown)
            .add(marinadeState.state.availableReserveBalance);
        var totalVirtualStakedLamports = totalLamportsUnderControl.sub(marinadeState.state.circulatingTicketBalance);
        return proportionalBN(msolAmount, totalVirtualStakedLamports, marinadeState.state.msolSupply);
    };
    SunriseStakeClient.prototype.computeLamportsFromBSol = function (bsolAmount, stakePoolInfo) {
        var bsolPrice = Number(stakePoolInfo.totalLamports) /
            Number(stakePoolInfo.poolTokenSupply);
        var solValue = Math.floor(Number(bsolAmount) * bsolPrice);
        return [bsolPrice, new BN(solValue)];
    };
    SunriseStakeClient.prototype.calculateExtractableYield = function (_a) {
        var balances = _a.balances, mpDetails = _a.mpDetails, lpDetails = _a.lpDetails, epochReport = _a.epochReport, bpDetails = _a.bpDetails;
        if (!this.marinadeState || !this.msolTokenAccount)
            throw new Error("init not called");
        // deposited in Stake Pool
        var solValueOfMSol = mpDetails.msolValue;
        var solValueOfBSol = bpDetails.bsolValue;
        // deposited in Liquidity Pool
        var solValueOfLP = lpDetails.lpSolValue;
        var gsolSupply = new BN(balances.gsolSupply.amount);
        var totalSolValueStaked = solValueOfMSol
            .add(solValueOfLP)
            .add(solValueOfBSol);
        var inflightTotal = epochReport.totalOrderedLamports;
        var extractableSOLGross = totalSolValueStaked
            .add(inflightTotal)
            .sub(gsolSupply);
        var fee = extractableSOLGross.muln(3).divn(1000);
        return extractableSOLGross.sub(fee);
    };
    /**
     * Create a new sunrise stake instance.
     * This sets the Anchor-specified wallet as the updateAuthority of this instance.
     * It also creates a new "gsol" token - each instance of sunrise is associated with its own token
     * @param treasury
     * @param gsolMint
     * @param env
     * @param options
     */
    SunriseStakeClient.register = function (treasury, gsolMint, env, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var sunriseStakeState, client, _a, accounts, parameters;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sunriseStakeState = Keypair.generate();
                        client = new SunriseStakeClient(setUpAnchor(), __assign(__assign({}, env), { state: sunriseStakeState.publicKey }), options);
                        return [4 /*yield*/, client.getRegisterStateAccounts(treasury, gsolMint.publicKey, options)];
                    case 1:
                        _a = _b.sent(), accounts = _a.accounts, parameters = _a.parameters;
                        return [4 /*yield*/, client.program.methods
                                .registerState(parameters)
                                .accounts(accounts)
                                .signers([gsolMint, sunriseStakeState])
                                .rpc()
                                .then(confirm(client.provider.connection))];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, client.init()];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, client.initEpochReport().then(confirm(client.provider.connection))];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, client];
                }
            });
        });
    };
    /**
     * Updates the configuration of the sunrise state instance. This can be used to set a new yield account,
     * or a new update authority, or set a new liquidity pool proportion.
     * @param newTreasury
     * @param newUpdateAuthority
     * @param newliqPoolProportion
     * @param newliqPoolMinProportion
     */
    SunriseStakeClient.prototype.update = function (_a) {
        var newTreasury = _a.newTreasury, newUpdateAuthority = _a.newUpdateAuthority, newliqPoolProportion = _a.newliqPoolProportion, newliqPoolMinProportion = _a.newliqPoolMinProportion;
        return __awaiter(this, void 0, void 0, function () {
            var _b, accounts, parameters;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.config)
                            throw new Error("init not called");
                        return [4 /*yield*/, this.getRegisterStateAccounts(newTreasury !== null && newTreasury !== void 0 ? newTreasury : this.config.treasury, this.config.gsolMint)];
                    case 1:
                        _b = _c.sent(), accounts = _b.accounts, parameters = _b.parameters;
                        return [4 /*yield*/, this.program.methods
                                .updateState(__assign(__assign({}, parameters), { updateAuthority: newUpdateAuthority !== null && newUpdateAuthority !== void 0 ? newUpdateAuthority : parameters.updateAuthority, liqPoolProportion: newliqPoolProportion !== null && newliqPoolProportion !== void 0 ? newliqPoolProportion : parameters.liqPoolProportion, liqPoolMinProportion: newliqPoolMinProportion !== null && newliqPoolMinProportion !== void 0 ? newliqPoolMinProportion : parameters.liqPoolMinProportion }))
                                .accounts(accounts)
                                .rpc()
                                .then(confirm(this.provider.connection))];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, this.init()];
                    case 3:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the user's current balance, and the current gsol supply
     */
    SunriseStakeClient.prototype.balance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var gsolBalancePromise, gsolSupplyPromise, msolTokenAccountAuthority, msolAssociatedTokenAccountAddress, msolLamportsBalancePromise, bsolTokenAccountAuthority, bsolAssociatedTokenAccountAddress, bsolLamportsBalancePromise, liqPoolAssociatedTokenAccountAddress, liqPoolBalancePromise, treasuryBalancePromise, holdingAccountBalancePromise, _a, gsolBalance, gsolSupply, msolLamportsBalance, lpBalance, treasuryBalance, bsolLamportsBalance, holdingAccountBalance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.marinadeState || !this.stakerGSolTokenAccount || !this.config)
                            throw new Error("init not called");
                        gsolBalancePromise = this.provider.connection
                            .getTokenAccountBalance(this.stakerGSolTokenAccount)
                            .catch(function (e) {
                            // Treat a missing account as zero balance
                            if (e.message.endsWith("could not find account")) {
                                return ZERO_BALANCE;
                            }
                            throw e;
                        });
                        gsolSupplyPromise = this.provider.connection.getTokenSupply(this.config.gsolMint);
                        msolTokenAccountAuthority = findMSolTokenAccountAuthority(this.config)[0];
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.marinadeState.mSolMintAddress,
                                owner: msolTokenAccountAuthority,
                            })];
                    case 1:
                        msolAssociatedTokenAccountAddress = _b.sent();
                        msolLamportsBalancePromise = this.provider.connection.getTokenAccountBalance(msolAssociatedTokenAccountAddress);
                        bsolTokenAccountAuthority = findBSolTokenAccountAuthority(this.config)[0];
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.env.blaze.bsolMint,
                                owner: bsolTokenAccountAuthority,
                            })];
                    case 2:
                        bsolAssociatedTokenAccountAddress = _b.sent();
                        bsolLamportsBalancePromise = this.provider.connection.getTokenAccountBalance(bsolAssociatedTokenAccountAddress);
                        return [4 /*yield*/, utils.token.associatedAddress({
                                mint: this.marinadeState.lpMint.address,
                                owner: msolTokenAccountAuthority,
                            })];
                    case 3:
                        liqPoolAssociatedTokenAccountAddress = _b.sent();
                        liqPoolBalancePromise = this.provider.connection.getTokenAccountBalance(liqPoolAssociatedTokenAccountAddress);
                        treasuryBalancePromise = this.provider.connection.getBalance(this.config.treasury);
                        holdingAccountBalancePromise = this.provider.connection.getBalance(this.env.holdingAccount);
                        return [4 /*yield*/, Promise.all([
                                gsolBalancePromise,
                                gsolSupplyPromise,
                                msolLamportsBalancePromise,
                                liqPoolBalancePromise,
                                treasuryBalancePromise,
                                bsolLamportsBalancePromise,
                                holdingAccountBalancePromise,
                            ])];
                    case 4:
                        _a = _b.sent(), gsolBalance = _a[0], gsolSupply = _a[1], msolLamportsBalance = _a[2], lpBalance = _a[3], treasuryBalance = _a[4], bsolLamportsBalance = _a[5], holdingAccountBalance = _a[6];
                        return [2 /*return*/, {
                                gsolBalance: gsolBalance.value,
                                gsolSupply: gsolSupply.value,
                                msolBalance: msolLamportsBalance.value,
                                msolPrice: this.marinadeState.mSolPrice,
                                liqPoolBalance: lpBalance.value,
                                treasuryBalance: treasuryBalance,
                                bsolBalance: bsolLamportsBalance.value,
                                holdingAccountBalance: holdingAccountBalance,
                            }];
                }
            });
        });
    };
    /**
     * Lock some staked gSOL in order to obtain an Impact NFT
     * @param lamports
     */
    SunriseStakeClient.prototype.lockGSol = function (lamports) {
        return __awaiter(this, void 0, void 0, function () {
            var transactions, recoverInstruction, lockTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.stakerGSolTokenAccount ||
                            !this.config ||
                            !this.marinade ||
                            !this.marinadeState ||
                            !this.lockClient)
                            throw new Error("init not called");
                        transactions = [];
                        return [4 /*yield*/, this.recoverTickets()];
                    case 1:
                        recoverInstruction = _a.sent();
                        if (recoverInstruction) {
                            transactions.push(new Transaction().add(recoverInstruction));
                        }
                        return [4 /*yield*/, this.lockClient.lockGSol(this.stakerGSolTokenAccount, this.env.impactNFT, lamports)];
                    case 2:
                        lockTx = _a.sent();
                        transactions.push(lockTx);
                        return [2 /*return*/, transactions];
                }
            });
        });
    };
    /**
     * Update the account that records the yield proportion allocated to a user, by virtue of their
     * locked gSOL.
     */
    SunriseStakeClient.prototype.updateLockAccount = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var transactions, currentEpoch, recoverInstruction, lockAccount, updateTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.config || !this.lockClient)
                            throw new Error("init not called");
                        transactions = [];
                        return [4 /*yield*/, this.provider.connection.getEpochInfo()];
                    case 1:
                        currentEpoch = _b.sent();
                        return [4 /*yield*/, this.recoverTickets()];
                    case 2:
                        recoverInstruction = _b.sent();
                        if (!recoverInstruction) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.sendAndConfirmTransaction(new Transaction().add(recoverInstruction))];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, this.getLockAccount()];
                    case 5:
                        lockAccount = (_b.sent()).lockAccount;
                        if (!lockAccount)
                            throw new Error("lock account not found");
                        if (!lockAccount.startEpoch || !lockAccount.updatedToEpoch)
                            throw new Error("lock account has not been locked?");
                        if (!(((_a = lockAccount.updatedToEpoch) === null || _a === void 0 ? void 0 : _a.toNumber()) < currentEpoch.epoch)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.lockClient.updateLockAccount()];
                    case 6:
                        updateTx = _b.sent();
                        transactions.push(updateTx);
                        _b.label = 7;
                    case 7: return [2 /*return*/, transactions];
                }
            });
        });
    };
    /**
     * Unlock a user's gSOL so that it can be unstaked
     */
    SunriseStakeClient.prototype.unlockGSol = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transactions, unlockTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.lockClient)
                            throw new Error("init not called");
                        if (!this.stakerGSolTokenAccount)
                            throw new Error("No stake found");
                        return [4 /*yield*/, this.updateLockAccount()];
                    case 1:
                        transactions = _a.sent();
                        return [4 /*yield*/, this.lockClient.unlockGSol(this.stakerGSolTokenAccount)];
                    case 2:
                        unlockTx = _a.sent();
                        transactions.push(unlockTx);
                        return [2 /*return*/, transactions];
                }
            });
        });
    };
    /**
     * Get a user's lock account, that records the yield proportion allocated to a user, by virtue of their
     * locked gSOL.
     * @param withRefresh
     */
    SunriseStakeClient.prototype.getLockAccount = function (withRefresh) {
        var _a, _b;
        if (withRefresh === void 0) { withRefresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var updatedYieldAccrued, _c, currentLevel, unrealizedYield;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.lockClient)
                            throw new Error("init not called");
                        if (!withRefresh) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.lockClient.refresh()];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2:
                        if (!this.lockClient.lockAccount) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.lockClient.calculateUpdatedYieldAccrued()];
                    case 3:
                        _c = _d.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _c = null;
                        _d.label = 5;
                    case 5:
                        updatedYieldAccrued = _c;
                        currentLevel = this.lockClient.getCurrentLevel();
                        unrealizedYield = updatedYieldAccrued === null || updatedYieldAccrued === void 0 ? void 0 : updatedYieldAccrued.sub((_b = (_a = this.lockClient.lockAccount) === null || _a === void 0 ? void 0 : _a.yieldAccruedByOwner) !== null && _b !== void 0 ? _b : ZERO);
                        return [2 /*return*/, {
                                lockAccount: this.lockClient.lockAccount,
                                lockAccountAddress: this.lockClient.lockAccountAddress,
                                tokenAccount: this.lockClient.lockTokenAccount,
                                tokenAccountAddress: this.lockClient.lockTokenAccountAddress,
                                currentLevel: currentLevel,
                                yieldToNextLevel: this.lockClient.getYieldToNextLevel(currentLevel === null || currentLevel === void 0 ? void 0 : currentLevel.index),
                                unrealizedYield: unrealizedYield !== null && unrealizedYield !== void 0 ? unrealizedYield : null,
                            }];
                }
            });
        });
    };
    /**
     * Create an instance of the Sunrise Client.
     * @param provider
     * @param stage
     * @param options
     */
    SunriseStakeClient.get = function (provider, stage, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = new SunriseStakeClient(provider, Environment[stage], options);
                        return [4 /*yield*/, client.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, client];
                }
            });
        });
    };
    return SunriseStakeClient;
}());
export { SunriseStakeClient };
//# sourceMappingURL=../../src/dist/index.js.map